var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/demographics-edit-gender.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"c-form__field\">\n\n    <fieldset>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12 o-small--6 u-no-gutters\">\n\n                <label for=\"profile.gender\" class=\"c-form__label\">\n                    ";
output += runtime.suppressValue((lineno = 9, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-gender",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n                </label>\n\n                <select aria-label=\"gender\" name=\"profile.gender\" id=\"profile.gender\" class=\"c-form__select js-account-demographics-form-item\" data-cm-element=\"account-gender\">\n\n                    ";
frame = frame.push();
var t_3 = (lineno = 14, colno = 50, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "helpers")),"genders"), "helpers[\"genders\"]", context, [runtime.contextOrFrameLookup(context, frame, "state")]));
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("gender", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n\n                    <option value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"value"), env.opts.autoescape);
output += "\" ";
if(runtime.memberLookup(((lineno = 16, colno = 64, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["profile"]))),"gender") == runtime.memberLookup((t_4),"value")) {
output += " selected ";
;
}
output += " >\n                        ";
output += runtime.suppressValue(env.getFilter("capitalize").call(context, runtime.memberLookup((t_4),"name")), env.opts.autoescape);
output += "\n                    </option>\n\n                    ";
;
}
}
frame = frame.pop();
output += "\n\n                </select>\n\n            </div>\n\n        </div>\n\n    </fieldset>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/demographics-edit-gender.j2"] , dependencies)